export const parseGender = (value: number) => {
  if (value === 1) return 'Male';
  else if (value === 2) return 'Female';
  return '—';
}

export const parseStatus = (value: number) => {
  if (value === 0) return 'Menunggu Persetujuan';
  else if (value === 1) return 'Pengajuan Diterima';
  else if (value === 2) return 'Pengajuan Ditolak';
  return '-';
}

export const parseStringToSeries = (value: string, series: number) => {
  let finalString = '';
  for (let ctr = 0; ctr < value.length; ctr++) {
    if (ctr % series === 0 && ctr > 0) {
      finalString = finalString + '-';
    }
    finalString = finalString + value[ctr];
  }
  return finalString;
}